import { render } from "./VideoHome.vue?vue&type=template&id=edcfb566&scoped=true"
import script from "./VideoHome.vue?vue&type=script&lang=js"
export * from "./VideoHome.vue?vue&type=script&lang=js"

import "./VideoHome.vue?vue&type=style&index=0&id=edcfb566&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edcfb566"]])

export default __exports__